<template>
  <v-row class="export-summary-cards">
    <!-- Active Exports Card -->
    <v-col cols="12" sm="4" md="4">
      <MetricCard
        title="Active Exports"
        :value="activeExportsCount"
        subtitle="Currently enabled"
        icon="mdi-database-export"
        icon-color="primary"
        :aria-label="`Active exports: ${activeExportsCount} currently enabled`"
        data-testid="summary-card-active"
      />
    </v-col>

    <!-- Next Scheduled Card -->
    <v-col cols="12" sm="4" md="4">
      <MetricCard
        title="Next Scheduled"
        :value="nextScheduledCount"
        subtitle="Due in next 24 hours"
        icon="mdi-clock-outline"
        icon-color="success"
        :aria-label="`Next scheduled: ${nextScheduledCount} exports due in next 24 hours`"
        data-testid="summary-card-scheduled"
      />
    </v-col>

    <!-- Recent Failures Card -->
    <v-col cols="12" sm="4" md="4">
      <MetricCard
        title="Recent Failures"
        :value="recentFailuresCount"
        :subtitle="recentFailuresCount === 1 ? 'Requires attention' : 'Require attention'"
        :icon="recentFailuresCount > 0 ? 'mdi-alert-circle' : 'mdi-check-circle'"
        :icon-color="recentFailuresCount > 0 ? 'error' : 'grey lighten-1'"
        :highlighted="recentFailuresCount > 0"
        highlight-color="error"
        :danger-value="recentFailuresCount > 0"
        :aria-label="`Recent failures: ${recentFailuresCount} exports ${recentFailuresCount === 1 ? 'requires' : 'require'} attention`"
        data-testid="summary-card-failures"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue'
import MetricCard from '../MetricCard/MetricCard.vue'

export default Vue.extend({
  name: 'ExportSummaryCards',

  components: {
    MetricCard
  },

  props: {
    /** Number of currently enabled exports */
    activeExportsCount: {
      type: Number,
      required: true
    },
    /** Number of exports scheduled to run in the next 24 hours */
    nextScheduledCount: {
      type: Number,
      required: true
    },
    /** Number of exports with failed last result */
    recentFailuresCount: {
      type: Number,
      required: true
    }
  }
})
</script>

<style scoped>
.export-summary-cards {
  margin-bottom: 24px;
}
</style>
